const TAG_RE = /^[a-z0-9-]{1,32}$/;

export const normalizeTag = (raw) => {
    if (typeof raw !== "string") return null;
    const cleaned = raw
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "")
        .slice(0, 32);
    return TAG_RE.test(cleaned) ? cleaned : null;
};

export const parseTagsInput = (input) => {
    if (!input || typeof input !== "string") return [];
    const seen = new Set();
    const out = [];
    input.split(",").forEach((piece) => {
        const tag = normalizeTag(piece);
        if (tag && !seen.has(tag)) {
            seen.add(tag);
            out.push(tag);
        }
    });
    return out;
};
